module.exports = __webpack_public_path__ + "media/images/playbutton_48-ab280cf2e1ab36732d1bc209a0f97684.png";